var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("box", { attrs: { huge: "" } }, [
    _c(
      "div",
      {
        staticClass:
          "_grid _grid-cols-2 _grid-cols-4--m _gap-4 _gap-6--m _tac _jc-c",
      },
      _vm._l(_vm.values, function (value) {
        return _c(
          "values-section-item",
          _vm._b({ key: value.valueID }, "values-section-item", value, false)
        )
      }),
      1
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }